// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"9ea4bfe0","390":"c4ea5c1b","403":"f8c09d43","658":"ee18e89e","767":"6d01c2b1","888":"452f9049","984":"b80ffbb2"}[chunkId] + ".chunk.js";
};